import { LazyLoadingSectionLogger, LoggingSection } from "@multiweb/logging";

const logger = LazyLoadingSectionLogger.create(LoggingSection.coreUI);

/**
 * Pomocné metody pro práci s UI
 * @includeToDoc
 */
export class UIUtils {
    /**
     * Vybere text na elementu
     * @param element element, ze kterého se vybere text
     */
    public static selectElementContents(element: HTMLElement): void {
        const range = document.createRange();
        range.selectNodeContents(element);
        const sel = window.getSelection();

        if (sel) {
            sel.removeAllRanges();
            sel.addRange(range);
        }
    }

    /**
     * Vloží text do clipboardu
     * @param text text, který se má vložit
     */
    public static pasteToClipboard(text: string): void {
        navigator.clipboard.writeText(text).then(() => {
            logger.log("Text has been pasted to the clipboard.");
        }, () => {
            logger.warn("Unable to paste text to the clipboard!");
        });
    }

    /**
     * Počká dokud není DOM zparsovaný a připravený na manipulaci
     */
    public static waitForDOMReady(): Promise<void> {
        if (document.readyState === "complete" || document.readyState === "interactive") {
            return Promise.resolve();
        }

        return new Promise<void>((resolve) => {
            document.addEventListener("DOMContentLoaded", () => resolve(), { once: true });
        });
    }
}
